import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Button } from "@arctheme-components/elements/Button/Button";
import { Image as ImageComponent } from "@arctheme-components/elements/Image/Image";
import "./PromotionTile.scss";

export const PromotionTile = ({ settings, promotion }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    return (
        <div
            className={`promotion-tile relative col-span-${promotion.column_span}`}
            style={{ color: promotion.settings?.text_colour || 'white' }}
        >
            <div className="promotion-tile__image-container relative">
                <div className="promotion-tile__image-overlay">
                    <ImageComponent
                        imageUrl={promotion.image}
                        isLazy={true}
                        classes="promotion-tile__image"
                    />
                    <div
                        className={`promotion-tile__content 
                          text-${promotion.settings?.content_alignment_mobile || 'left'} 
                          lg:text-${promotion.settings?.content_alignment_desktop || 'left'} 
                          justify-${promotion.settings?.content_vertical_position_mobile || 'end'} 
                          lg:justify-${promotion.settings?.content_vertical_position_desktop || 'end'}`}
                        >
                        <div
                            className="promotion-tile__container"
                            style={{
                                color: promotion.settings?.text_colour || 'white',
                                backgroundColor: promotion.background_color || 'var(--background-color)',
                            }}
                        >
                            <div className="promotion-tile__subtitle">
                                <h4 className={`${isMobile ? promotion.settings?.subtitle_font_class_mobile || 'b2' : promotion.settings?.subtitle_font_class_desktop || 'b2'}`}>
                                    {promotion.subtitle}
                                </h4>
                            </div>
                            <div className="promotion-tile__title">
                                <h3 className={`${isMobile ? promotion.settings?.title_font_class_mobile || 'h5' : promotion.settings?.title_font_class || 'h3'}`}>
                                    {promotion.title}
                                </h3>
                            </div>
                            <div className="promotion-tile__link">
                                {promotion.link && (
                                    <Button
                                        label={promotion.link_label}
                                        style={isMobile ? promotion.settings?.button_style_mobile : promotion.settings?.button_style_desktop || 'text'}
                                        type={isMobile ? promotion.settings?.button_style_mobile : promotion.settings?.button_style_desktop || 'text'}
                                        icon={isMobile ? (promotion.settings?.has_icon_mobile ? 'ur-arrow' : 'ur-arrow') : (promotion.settings?.has_icon_desktop ? 'ur-arrow' : 'ur-arrow')}
                                        link={promotion.link}
                                        reverse={true}
                                        buttonStyle={{ color: promotion.settings?.text_colour || 'white' }}
                                        onClick={undefined}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PromotionTile;
